import {BaseEntity} from "../../entities/BaseEntity";
import { StateService } from "@uirouter/angularjs";
import { ServerImportModel } from "../../models/serverimport/ServerImportModel";
import { NotificationService } from "../../services/NotificationService";

export class ServerImportSummaryCtrl<T extends BaseEntity>{
    public static $inject = ['$scope','$state','ImportModel'];
    constructor(public $scope: any, public stateService: StateService, public model: ServerImportModel<T>, public notifyService: NotificationService) {
        this.$scope.vm = this;
    }
    startOver():void{
        this.stateService.go(this.model.getRoute("fileupload"));
    }
}
